import { css } from 'emotion'

export const flexSpaceBetweenStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
